"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAdminUserList = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/user/list");
const Actions = require("../../actions/user/list");
const sok_types_1 = require("@caddigital/sok-types");
function parseQueryString(action) {
    return Object.entries(action.payload)
        .map(([key, value]) => `${key}=${value !== undefined && encodeURIComponent(value.toString())}`)
        .join('&');
}
function fetchAdminUserList(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_USER_LIST_REQUEST &&
        typeof action.payload.search === 'string' &&
        action.payload.search.length > 0), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/admin/user/?${parseQueryString(action)}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .interface({
            total: t.number,
            users: t.array(sok_types_1.User.iUser)
        })
            .decode(response);
        const act = validation.fold((e) => Actions.fetchUserListFailed((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchUserListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchUserListFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchAdminUserList = fetchAdminUserList;
//# sourceMappingURL=list.js.map